import { useEffect } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { parse } from "qs";

import { useDispatch, useSelector } from "@/redux/hooks";
import { getGeoSlug } from "@/redux/selectors/location";
import { disableLocationChangeReload } from "@/redux/slices/header";
import { leaflyShopStringify } from "@/utils/qs";

const useSyncUrlWithLocation = () => {
  const { push } = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const dispatch = useDispatch();
  const reduxLocationSlug = useSelector(getGeoSlug);

  // * Disable the location change reload from the LocationPicker component since we are handling the reload here
  dispatch(disableLocationChangeReload());

  useEffect(() => {
    if (reduxLocationSlug) {
      // * City / State was successfully resolved from Redux
      const { location: routeLocationSlug, ...otherQueryParams } = parse(
        searchParams?.toString() || "",
      );

      if (routeLocationSlug && routeLocationSlug !== reduxLocationSlug) {
        // * ...but the location query string param does not match
        const newQueryString = leaflyShopStringify({
          location: reduxLocationSlug,
          ...otherQueryParams,
        });
        push(`${pathname}${newQueryString ? `?${newQueryString}` : ""}`);
      }
    }
  }, [push, pathname, searchParams, reduxLocationSlug]);
};

export default useSyncUrlWithLocation;
